// @flow

import * as React from 'react';
import { withRouter } from 'react-router';
import classnames from 'classnames';
import { connect } from 'react-redux';

import styles from './styles.scss';

import { setCurrentPlace } from '../../redux/actionsCreators';
import { preloader, homeTween, sailAnimation, fadeInRight, animateMenuItems } from '../../utils/animation';

import type { PlaceType } from '../../api/types';

type Props = {
  history: Object,
  location: Object,
  places: Array<PlaceType>,
  currentPlace: PlaceType,
  setCurrentPlace: (currentPlace: PlaceType) => void,
};

type State = {
  hoveredCity: null | string,
};

class LocationToggle extends React.Component<Props, State> {
  state = {
    hoveredCity: null,
  };

  componentDidUpdate = (prevProps: Props, prevState: State) => {
    if (this.state.hoveredCity === prevState.hoveredCity || this.props.location.pathname !== '/') return;

    this.toggleClassNames(prevState.hoveredCity, this.state.hoveredCity);

    const video = document.querySelector('#video');
    const img = document.querySelector('#cityImg');

    if (this.state.hoveredCity) {
      // $FlowFixMe
      video.pause();
      // $FlowFixMe
      homeTween(video, img).play();
    } else {
      // $FlowFixMe
      video.play();
      // $FlowFixMe
      homeTween(video, img).reverse();
    }
  };

  makeValidClassName = (name: string): string => name && name.replace(/\s+/g, '-').toLowerCase();

  toggleClassNames = (prevCity: string | null, currentCity: string | null) => {
    if (!document || !document.body) return;

    const { classList } = document.body;

    if (prevCity) {
      const prevClass = this.makeValidClassName(prevCity);

      if (classList.contains(prevClass)) {
        classList.remove(prevClass);
      }
    }

    if (!currentCity) return;

    const nextClass = this.makeValidClassName(currentCity);

    classList.add(nextClass);
  };

  handleClick = (placeName: string) => {
    if (placeName !== this.props.currentPlace.name) {
      this.setPlace(placeName);

      if (this.props.location.pathname === '/') {
        this.props.history.push('/categories');
      }

      if (this.props.location.pathname === '/categories') {
        preloader(() => {
          sailAnimation(document.querySelectorAll('.card .imageWrap').length).play();
          animateMenuItems().play();
          fadeInRight('[data-animation="top"]').delay(0.1);
          fadeInRight('[data-animation="bottom"]').delay(0.3);
        }).play();
      }
    }
  };

  setPlace = placeName => {
    const newPlace = this.props.places.find((place: PlaceType): boolean => place.name === placeName);

    if (newPlace) {
      localStorage.setItem('currentPlace', JSON.stringify(newPlace));

      this.props.setCurrentPlace({ name: newPlace.name, image: newPlace.image, id: newPlace.id });
    }
  };

  handleMouseEnter = (city: string) => this.setState({ hoveredCity: city });

  handleMouseLeave = () => this.setState({ hoveredCity: null });

  render() {
    return (
      <ul className={classnames(styles['city-list'])}>
        <li
          className={classnames({ active: this.props.currentPlace.name === 'Los Angeles' })}
          onClick={(): void => this.handleClick('Los Angeles')}
          onMouseEnter={(): void => this.handleMouseEnter('Los Angeles')}
          onMouseLeave={this.handleMouseLeave}
          data-target="#imgLA"
        >
          <span data-animation="top" className={styles.item}>
            Los Angeles
          </span>
        </li>
        <li data-animation="width" className={styles.line} />
        <li
          className={classnames({
            active: this.props.currentPlace.name === 'New York',
            disabled: this.props.location.pathname.includes('studios') || this.props.location.pathname.includes('cafe'),
          })}
          onClick={(): void => this.handleClick('New York')}
          onMouseEnter={(): void => this.handleMouseEnter('New York')}
          onMouseLeave={this.handleMouseLeave}
          data-target="#imgNY"
        >
          <span data-animation="bottom" className={styles.item}>
            New York
          </span>
        </li>
      </ul>
    );
  }
}

const mapStateToProps = (state): Object => ({
  places: state.places,
  currentPlace: state.currentPlace,
});

const mapDispatchToProps = (dispatch): Object => ({
  setCurrentPlace(currentPlace) {
    dispatch(setCurrentPlace(currentPlace));
  },
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(LocationToggle),
);



// WEBPACK FOOTER //
// ./src/components/LocationToggle/index.js